import { makeApiCall, makeApiCallWithImages } from "../apiRequest";

export default {
  state: {
    employeeList: [],
    allManagersList: [],
    employeeRoleList: [],
    employeeListWithoutManager: [],
    employeeById: [],
    departmentEmployees: [],
    managersForAssign: [],
    alldepartmentEmployee: [],
    downloadSampleFile: [],
  },
  getters: {
    getEmployeeList: (state) => state.employeeList,
    getAllManagersList: (state) => state.allManagersList,
    getAllDepartmentEmployee: (state) => state.alldepartmentEmployee,
    getEmployeeRoleList: (state) => state.employeeRoleList,
    getEmployeeListWithoutManager: (state) => state.employeeListWithoutManager,
    getEmployeeById: (state) => state.employeeById,
    getDepartmentEmployees: (state) => state.departmentEmployees,
    getManagersForAssign: (state) => state.managersForAssign,
  },
  actions: {
    async getEmployeeListWithoutManager({ commit }) {
      const response = await makeApiCall("Users/GetAllUsersEmployee", "GET");
      if (!response.error) {
        commit("setEmployeeListWithoutManager", response.data.data);
      }
    },
    async getEmployeeList({ commit }, obj) {
      let url = `employee/getAll`;

      const response = await makeApiCall(url, "POST", obj);
      if (!response.error) {
        commit("setEmployeeList", response.data);
      }
      return response;
    },
     async getUseMangerInAssignTempalte({ commit }, payload) {
      const response = await makeApiCall(
        `employee/getManagersUseInAssignTemplate?assignTemplateId=${payload}`,
        "GET"
      );
      return response;
    },
    async getAllManagersList({ commit }, payload) {
      const response = await makeApiCall(
        `departments/getAllManagers?isDepartmentAssigned=${payload}`,
        "POST"
      );
      if (!response.error) {
        commit("setAllManagersList", response.data.data);
      }
    },
    async getAllDepartmentEmployee({ commit }, payload) {
      const response = await makeApiCall(
        `departments/getAllEmployees?isDepartmentAssigned=${payload}`,
        "POST"
      );
      if (!response.error) {
        commit("setAllDepartmentEmployee", response.data.data);
      }
    },
    async getEmployeeRoleList({ commit }) {
      const response = await makeApiCall("Roles/GetAllRole", "GET");
      if (!response.error) {
        commit("setEmployeeRoleList", response.data.data.result);
      }
    },
    async createEmployee({ commit }, payload) {
      const response = await makeApiCall("employee/save", "POST", payload);
      return response;
    },
    async resendEmployeeEmail({ commit }, payload) {
      const response = await makeApiCall(
        "employee/resendEmail",
        "POST",
        payload
      );
      return response;
    },
    async sendEmployeeEmail({ commit }, payload) {
      const response = await makeApiCall("employee/sendEmail", "POST", payload);
      return response;
    },
    async bulkSendEmployeeEmail({ commit }, payload) {
      const response = await makeApiCall(
        "employee/bulkSendEmail",
        "POST",
        payload
      );
      return response;
    },
    async deleteEmployee({ commit }, payload) {
      const response = await makeApiCall(`employee/delete`, "DELETE", payload);
      return response;
    },
    async getEmployeeById({ commit }, id) {
      const response = await makeApiCall(`Users/GetUserById?id=${id}`, "GET");
      if (!response.error) {
        commit("setEmployeeById", response.data.data[0]);
      }
    },
    async updateEmployee({ commit }, payload) {
      const response = await makeApiCallWithImages(
        "Users/UpdateUser",
        "PUT",
        payload
      );
      return response;
    },
    async getDepartmentEmployees({ commit }, id) {
      const response = await makeApiCall(
        `Departments/GetAllEmployeeForUpdateDepartment?id=${id}`
      );
      if (!response.error) {
        commit("setDepartmentEmployees", response.data.data);
      }
    },
    async getManagersForAssign({ commit }) {
      const response = await makeApiCall(
        "AssignedTemplate/GetAllManagersForAssign"
      );
      if (!response.error) {
        commit("setManagersForAssign", response.data.data);
      }
    },
    async saveExcelFile({ commit }, payload) {
      const url = `employee/saveList`;
      const response = await makeApiCall(url, "POST", payload);
      return response;
    },
  },
  mutations: {
    setEmployeeList: (state, payload) => (state.employeeList = payload),
    setAllDepartmentEmployee: (state, payload) =>
      (state.alldepartmentEmployee = payload),
    setAllManagersList: (state, payload) => (state.allManagersList = payload),
    setEmployeeRoleList: (state, payload) => (state.employeeRoleList = payload),
    setEmployeeListWithoutManager: (state, payload) =>
      (state.employeeListWithoutManager = payload),
    setEmployeeById: (state, payload) => (state.employeeById = payload),
    setDepartmentEmployees: (state, payload) =>
      (state.departmentEmployees = payload),
    setManagersForAssign: (state, payload) =>
      (state.managersForAssign = payload),
  },
};
